import React from 'react';
import RadioPage from '@domain/pages/RadioPage';

const counterpartyKnown = 'counterpartyKnown';
function CounterPartyKnown() {
  const fields = [{
    id: 1,
    value: 'yes',
    triggerKeys: [106, 74, 49],
    label: 'Ja'
  }, {
    id: 2,
    value: 'no',
    triggerKeys: [110, 78, 50],
    label: 'Nee'
  }
  ]

  return <RadioPage fieldName={counterpartyKnown} styleLabel={'counterparty'} fields={fields} />
}

export default CounterPartyKnown;